import getPublishedStateHeader from '../../helpers/getPublishedStateHeader';

export const REQUEST = 'SITE_FOOTER_REQUEST';
export const SUCCESS = 'SITE_FOOTER_SUCCESS';
export const FAILURE = 'SITE_FOOTER_FAILURE';

const initialState = {
  loaded: false,
};

export default function siteFooterReducer(state = initialState, action) {
  switch (action.type) {
    case REQUEST:
      return Object.assign({}, state, {
        loading: true,
      });

    case SUCCESS:
      return Object.assign(
        {},
        {
          loaded: true,
          statusCode: action.data.statusCode,
          ...action.data.json,
        },
      );

    case FAILURE:
      return Object.assign(
        {},
        {
          error: true,
          statusCode: action.data.statusCode,
          ...action.data.json,
        },
      );

    default:
      return state;
  }
}

export function fetchSiteFooterRequest(data) {
  return { type: REQUEST, data };
}

export function fetchSiteFooterSuccess(data) {
  return { type: SUCCESS, data };
}

export function fetchSiteFooterFailure(data) {
  return { type: FAILURE, data };
}

export function fetchSiteFooterAction() {
  return function (dispatch, getState, { Api, i18n }) {
    dispatch(fetchSiteFooterRequest());

    const {
      pageConfig: { previewMode, siteId, siteTypePath },
    } = getState();

    return Api()
      .cache(true)
      .service('ContentService')
      .version('v1')
      .setup({
        headers: {
          'Accept-Language': i18n.language,
          'Published-State': getPublishedStateHeader(previewMode),
        },
      })
      .fetchSiteFooter({ siteId, siteTypePath })
      .then((response) => {
        if (response.statusCode === 200) {
          return dispatch(fetchSiteFooterSuccess(response));
        } else {
          return dispatch(fetchSiteFooterFailure(response));
        }
      });
  };
}
